import { render } from "./NetworkBadge.vue?vue&type=template&id=7439b574"
import script from "./NetworkBadge.vue?vue&type=script&lang=js"
export * from "./NetworkBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__